import {TariffLink} from './tariff.i';

export const ACCOUNT_INACTIVE_STATE_ID = 1;
export const ACCOUNT_ACTIVE_STATE_ID   = 2;

export interface CustomerAccountLink {
    id: number;
    poolName: string;
    liquidityAccountId: number;
    liquidityAccountName: string;
    iban: string;
    allowIncoming: boolean;
    allowOutgoing: boolean;
}

export interface CustomerAccountState {
    id: number;
    name: string
}

export interface CustomerAccountDetail {
    id: number;
    name: string;
    number: string;
    type: {
        id: number;
        name: string;
    };
    available_balance: {
        amount: number;
        currency_code: string;
    };
    balance: {
        amount: number;
        currency_code: string;
    };
    last_transfer_date: string;
    links: CustomerAccountLink[];
    uses_based_tariff: boolean;
    tariff: TariffLink;
    state: string;
    stateDetails: CustomerAccountState;
    ownerProfileBlocked: boolean;
}

export interface CustomerAccountLink {
    id: number;
    poolName: string;
    liquidityAccountId: number;
    liquidityAccountName: string;
    iban: string;
    allowIncoming: boolean;
    allowOutgoing: boolean;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/api/entity/customer-account.i.ts